function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.895 30.27L4 27h27.318L7.895 30.27zM12.304 25v-7.131h3.043L20.617 25H26l-6.365-8.608a7.985 7.985 0 003.282-6.466c0-4.373-3.505-7.926-7.81-7.926H8v23h4.304zm0-18.627h2.803c1.933 0 3.514 1.598 3.514 3.561 0 1.964-1.581 3.57-3.514 3.57h-2.803v-7.14.009z",
    fill: props.color
  }));
}

export default SvgIconRakutenFilled;